import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoX = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 13,
	viewBox: "0 0 12 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_1418_47410)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M7.14163 5.19281L11.6089 0H10.5503L6.67137 4.50884L3.57328 0H0L4.68492 6.81817L0 12.2636H1.05866L5.15491 7.50213L8.42672 12.2636H12L7.14137 5.19281H7.14163ZM5.69165 6.87824L5.21697 6.1993L1.44011 0.796939H3.06615L6.11412 5.15682L6.5888 5.83575L10.5508 11.5029H8.92476L5.69165 6.8785V6.87824Z",
			fill: "#0C0C0C"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1418_47410",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 12,
			height: 12.2699,
			fill: "white"
		})
	}) })]
});
export { SvgLogoX as ReactComponent };
